import {Injectable} from '@angular/core';
import {GenericService} from "../../core/commons/generic.service";
import {MinistryArea} from "../domain/ministry/ministry-area";
import {QueryOptions} from "../../core/commons/query.options";
import {AuthService} from "../../core/security/auth.service";
import {Observable} from "rxjs/Observable";
import {RequestMethod} from "@angular/http";
import {environment} from "../../../environments/environment";

@Injectable()
export class MinistryAreaService extends GenericService<MinistryArea> {

    constructor(authService: AuthService) {
        super(authService);
    }

    protected valueToEntity(value: Object): MinistryArea {
        return new MinistryArea(value);
    }

    protected getResourcePath(): string {
        return '/ministry-areas'
    }

    getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    public publicFindAll(): Observable<MinistryArea[]> {
        let req = this.buildRequest(RequestMethod.Get);
        return this.authService.publicRequest(environment.backendHost + environment.backendPublicApiPath + this.getResourcePath() + "/all", req)
            .map(res => res.json().map( t => this.valueToEntity(t) ) );
    }

}



// WEBPACK FOOTER //
// ./src/app/profile/service/ministry-area.service.ts